<template>
  <!-- 日志列表 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <!-- 操作时间 -->
        <el-form-item :label="$t('pages.equipment.text45')">
          <el-date-picker
            v-model="startAt"
            type="datetime"
            :placeholder="$t('public.text2')"
            @change="startChange"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
          <span style="margin: 0 8px">-</span>
          <el-date-picker
            v-model="stopAt"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 日志类别 -->
        <el-form-item :label="$t('pages.system.text55')">
          <el-select
            v-model="searchParams.apiName"
            clearable
            :placeholder="$t('pages.system.text55')"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 按钮区域 -->
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['logList:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['logList:reset']"
        ></DiluButton>
      </div>
    </div>
    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      :total="total"
      @currentChange="currentChange"
    >
      <el-table-column prop="date" label="#" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <!-- 操作人账号 -->
      <el-table-column
        prop="userName"
        :label="$t('pages.system.text61')"
        width="200"
        align="center"
      >
      </el-table-column>
      <!-- 日志类别 -->
      <el-table-column
        prop="apiName"
        :label="$t('pages.system.text55')"
        align="center"
      >
      </el-table-column>
      <!-- 操作内容 -->
      <el-table-column
        prop="apiInfo"
        :label="$t('pages.system.text56')"
        align="center"
      >
      </el-table-column>
      <!-- IP -->
      <el-table-column prop="requestIp" label="IP" width="120" align="center">
      </el-table-column>
      <!-- 操作日期 -->
      <el-table-column
        prop="createdAt"
        :label="$t('pages.system.text60')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button @click="details(scope.row)" type="text">{{
              $t("omission.text35")
            }}</el-button>
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 请求参数弹窗 -->
    <el-dialog
      :title="$t('omission.text35')"
      :visible.sync="dialogVisible"
      width="600px"
      padding-top="10px"
    >
      <RequestParam :json="jsonData" />
    </el-dialog>
  </div>
</template>

<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import RequestParam from "./module/RequestParam";
import { resetDate } from "../../../utils/util/validate";
import { mapState } from "vuex";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        //选中的开始日期前的时间禁选
        disabledDate: (time) => {
          return time.getTime() < this.startAt;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      searchParams: {
        belongCustomer: "", // 归属客户
        apiName: "", // 日志类别
        compare: "", // 比较条件
        createdAt: "", // 操作日期
        duration: "", // 执行时长
        pageNum: 1, // 页码
        pageSize: 10, // 每页条数
        realName: "", // 操作人
        requestUrl: "", // 请求地址
      },
      dialogVisible: false, //详情弹窗状态
      startAt: "", //开始日期
      stopAt: "", //结束日期
      total: 0,
      options: [
        {
          value: "login",
          label: this.$t("pages.login.text7"), //登录
        },
        {
          value: "logout",
          label: this.$t("pages.system.text58"), //登出
        },
        {
          value: "add",
          label: this.$t("button.add"), //新增
        },
        {
          value: "delete",
          label: this.$t("button.delete"), //删除
        },
        {
          value: "edit",
          label: this.$t("button.edit"), //编辑
        },
        {
          value: "query",
          label: this.$t("button.query"), //查询
        },
        {
          value: "import",
          label: this.$t("button.import"), //导入
        },
        {
          value: "export",
          label: this.$t("button.export"), //导出
        },
        {
          value: "review",
          label: this.$t("button.examine"), //审核
        },
        {
          value: "bind",
          label: this.$t("pages.equipment.text42"), //绑定
        },
        {
          value: "unbind",
          label: this.$t("pages.equipment.text43"), //解绑
        },
        {
          value: "other",
          label: this.$t("pages.research.text88"), //其他
        },
      ],
      value: "",
      tableConfig: {
        isTree: false,
        isPage: true, //打开分页功能
      },
      jsonData: {}, //请求参数
      tableData: [],
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluTable,
    DiluButton,
    RequestParam,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {
    this.stopAt = resetDate(new Date()); // 当前时间
    this.startAt = this.fun_date(-7); //七天前的时间
    this.admList();
  },
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.admList();
    },
    //选择开始日期改变结束日期置空重选
    startChange() {
      this.stopAt = "";
    },
    // 请求参数
    details(e) {
      if (e.requestParam == "" || e.requestParam == "{}") {
        this.jsonData = [this.$t("omission.text36")];
      } else {
        this.jsonData = JSON.parse(e.requestParam);
      }
      this.dialogVisible = true;
    },
    // 翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams = {
          belongCustomer: "", // 归属客户
          apiName: "", // 日志类别
          compare: "", // 比较条件
          createdAt: [], // 操作日期
          duration: "", // 执行时长
          pageNum: 1, // 页码
          pageSize: 10, // 每页条数
          realName: "", // 操作人
          requestUrl: "", // 请求地址
        };
      }
      this.searchParams.pageNum = e;
      this.admList();
    },
    // 重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        belongCustomer: "", // 归属客户
        apiName: "", // 日志类别
        compare: "", // 比较条件
        createdAt: [], // 操作日期
        duration: "", // 执行时长
        pageNum: 1, // 页码
        pageSize: 10, // 每页条数
        realName: "", // 操作人
        requestUrl: "", // 请求地址
      };
      this.total = 0;
      this.startAt = ""; //开始日期
      this.stopAt = ""; //结束日期
      this.admList();
    },
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    // 获取当前时间
    fun_date(aa) {
      var date1 = new Date();
      var date2 = new Date(date1);
      var hour = date2.getHours();
      var minute = date2.getMinutes();
      var second = date2.getSeconds();
      // 获取当前时间前后aa天时间
      date2.setDate(date1.getDate() + aa);
      var time2 =
        date2.getFullYear() +
        "-" +
        (date2.getMonth() + 1) +
        "-" +
        date2.getDate() +
        " " +
        this.formatTen(hour) +
        ":" +
        this.formatTen(minute) +
        ":" +
        this.formatTen(second);
      return time2;
    },
    // 获取日志列表
    admList() {
      if (this.stopAt && this.startAt) {
        this.stopAt = resetDate(this.stopAt); // 结束时间
        this.startAt = resetDate(this.startAt); // 开始时间
        this.searchParams.createdAt = [this.startAt, this.stopAt];
      } else {
        this.searchParams.createdAt = [];
      }
      if (this.startAt) {
        if (!this.stopAt) {
          return this.$message.error(this.$t("public.text3")); //请选择结束日期
        }
      }
      if (this.stopAt) {
        if (!this.startAt) {
          return this.$message.error(this.$t("public.text2")); //请选择开始日期
        }
      }
      this.searchParams.belongCustomerId = this.platformData.id + "";
      this.request.admList(this.searchParams).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.dataMaxCount;
      });
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>